import registerMyloginHeader from './mylogin-header'
import registerPasswordChecker from './password-checker'

export default function registerComponents(Alpine) {
    registerMyloginHeader(Alpine)
    registerPasswordChecker(Alpine)
}
